import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'

import { isFullyAuthenticated, track, tourName } from '../../util'
import { actions, updateUi } from '../../lib'
import Logo from './Logo'
import Hamburger from './Hamburger'
import Nav from './Nav'
import { UserMenu, WelcomeNav } from './SidebarNav'
import HelpIcon from '../../help/components/HelpIcon'
import { selectors as helpSelectors } from '../../help/redux'

const Container = styled.header`
  position: absolute;
  top: 0;
  display: flex;
  width: 100%;
  height: 70px;
  background: ${vars.white};

  a {
    color: ${vars.grayLight};
    text-decoration: none;
  }
`

const Section = styled.section`
  height: 71px;
  border-bottom: 1px solid ${vars.grayLighter};

  &.loggedIn {
    border-bottom: 0;

    @media screen and (max-width: ${vars.screenMd}) {
      border-bottom: 1px solid ${vars.grayLighter};
    }
  }

  &:nth-of-type(1) {
    width: 25%;
    min-width: 25%;
  }

  &:nth-of-type(2) {
    width: 75%;
    padding: 0;
    padding-left: 30px;

    > nav {
      height: 100%;
    }
  }

  &:nth-of-type(3) {
    padding: 0 2rem;
    cursor: pointer;
  }
`

export class Header extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    impersonatedUser: PropTypes.object.isRequired,
    authLogout: PropTypes.func.isRequired,
    stopImpersonating: PropTypes.func.isRequired,
    appShellUi: PropTypes.object.isRequired,
    updateUi: PropTypes.func.isRequired,
    profileChangeInProgress: PropTypes.bool.isRequired,
    hasNewReleaseNotes: PropTypes.bool.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    onChangeProfile: PropTypes.func.isRequired,
  }

  state = {
    userMenuOpen: false,
    mobileMenuOpen: false,
  }

  onLogout = () => {
    this.props
      .authLogout()
      .then(() => this.context.router.push('/login'))
      .catch(err => {
        if (err !== 'impersonated') {
          console.error(err)
        }
      })

    this.setState({
      userMenuOpen: false,
      mobileMenuOpen: false,
    })
  }

  isLoggedIn() {
    return isFullyAuthenticated() && !!Object.keys(this.props.user).length
  }

  toggleMenu = () => {
    if (this.isLoggedIn()) {
      const userMenuOpen = !this.state.userMenuOpen
      this.setState({ userMenuOpen })
      track.userMenu({ event: userMenuOpen ? 'enter' : 'exit' })
    } else {
      this.setState({
        mobileMenuOpen: !this.state.mobileMenuOpen,
      })
    }
  }

  toggleHelpCenter = () => {
    const showHelpCenter = !this.props.appShellUi.showHelpCenter
    this.props.updateUi({ showHelpCenter })
    track.helpCenter({ event: showHelpCenter ? 'enter' : 'exit' })
  }

  render() {
    if (!this.props.appShellUi.showHeader) return null

    const {
      user,
      impersonatedUser,
      authLogout,
      stopImpersonating,
      appShellUi,
      profileChangeInProgress,
      hasNewReleaseNotes,
    } = this.props

    const loggedIn = this.isLoggedIn()

    return (
      <Container>
        {!this.state.userMenuOpen && (
          <Hamburger
            loggedIn={loggedIn}
            userMenuOpen={this.state.userMenuOpen}
            mobileMenuOpen={
              this.state.mobileMenuOpen || this.state.userMenuOpen
            }
            onClick={this.toggleMenu}
          />
        )}
        <Section className={loggedIn && 'loggedIn'}>
          <Logo loggedIn={loggedIn} mode={appShellUi.logoMode} />
        </Section>
        <Section>
          <Nav
            user={user}
            impersonatedUser={impersonatedUser}
            authLogout={authLogout}
            appShellUi={appShellUi}
            onUserMenuClick={this.toggleMenu}
          />
        </Section>
        {loggedIn ? (
          <UserMenu
            user={user}
            impersonatedUser={impersonatedUser}
            stopImpersonating={stopImpersonating}
            open={this.state.userMenuOpen}
            onLogout={this.onLogout}
            onClose={this.toggleMenu}
            onChangeOrganization={this.context.onChangeProfile}
            profileChangeInProgress={profileChangeInProgress}
            isInternal={appShellUi.isInternal}
          />
        ) : (
          <WelcomeNav open={this.state.mobileMenuOpen} />
        )}
        {loggedIn && (
          <Section>
            <HelpIcon
              hasText
              color={vars.grayLight}
              onClick={this.toggleHelpCenter}
              showNotificationBubble={hasNewReleaseNotes}
              data-tour={tourName('help-icon')}
            />
          </Section>
        )}
      </Container>
    )
  }
}

export default connect(
  state => ({
    user: state.auth.user,
    impersonatedUser: state.auth.impersonatedUser,
    appShellUi: state.appShellUi,
    profileChangeInProgress: state.auth.profileChangeInProgress,
    hasNewReleaseNotes: !!helpSelectors.getUnseenReleaseNotesCount(state),
  }),
  {
    authLogout: actions.authLogout,
    stopImpersonating: actions.authStopImpersonating,
    updateUi,
  },
  null,
  { pure: false }
)(Header)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Header.js